<style scoped>
	/*<!---->*/
  .banner_div {
    padding-top: 32px;
  }

  .topmsg {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .erwm {
    width: 85px;
    height: 85px;
    background: #000;
    margin-right: 26px;
  }

  .font1 {
    font-size: 14px;
    color: #000;
    margin-bottom: 12px;
  }

  .font2 {
    color: #4a4a4a;
    font-size: 14px;
  }

  h3 {
    text-align: left;
  }

  h3 span {
    color: #ea2323;
    font-size: 14px;
  }

  .m-l {
    display: flex;
    align-items: center;
  }

  .m-r {
    align-items: center;
    display: flex;
    font-size: 14px;
    color: #000;
  }

  .m-r span {
    color: #EA2323;
    font-size: 24px;
    font-weight: bold;
  }

  .pay-box {
    width: 100%;
    padding: 61px 33px;
    background: #fff;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    margin-top: 27px;
    box-sizing: border-box;
  }

  .checked-shadow{
    box-shadow: 0 4px 24px 0 rgba(206, 206, 206, 0.43) ;
  }
  .zfb-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  .z-l {
    display: flex;
    align-items: center;
  }

  .checkbox {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #E2E2E2;
    border-radius: 3px;
    margin-right: 24px;
  }
  .checkbox>.checked-style{
    width: 8px;
    height: 15px;
    display: inline-block;
    border-right: 2px solid #1296DB;
    border-bottom: 2px solid #1296DB;
    transform: rotate(45deg);
  }

  .b {
    margin-left: 6px;
    width: 34px;
    height: 20px;
    color: #fff;
    text-align: center;
    font-size: 12px;
    background-image: linear-gradient(#1296DB, #427DD6);
    line-height: 20px;
    border-radius: 2px;
  }

  .img {
    width: 40px;
    height: 40px;
  }

  .img img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .box-font {
    font-size: 18px;
    color: #1A1A1A;
    margin-right: 67px;
  }

  .box-font-m {
    color: #666666;
    font-size: 14px;
  }

  .z-r {
    font-size: 14px;
    color: #000000;
    display: flex;
    align-items: center;
  }

  .z-r span {
    color: #EA2323;
    font-size: 24px;
    font-weight: bold;
    margin: 0 10px;
  }

  .paypal-box {
    margin-top: 40px;
  }

  .btn-box {
    padding-left: 70px;
  }

  .btn {
    width: 220px;
    height: 50px;
    background-image: linear-gradient(#3F9FEA, #0573CB);
    margin-top: 54px;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }

  /*  input box   */
  .amount-input-box{
    display: flex;
    align-items: center;
    margin-bottom: 50px;
  }
  .amount-input-box > .amount-title{
    font-size: 16px;
    font-weight: bold;
  }
  .amount-input-box > .amount-input{
    border: 1px solid #26AFFD;
    padding: 5px 10px;
    height: 30px;
    width: 300px;
    font-size: 16px;
  }
</style>

<template>
	<div id="app">
		<HeaderTop></HeaderTop>
		<HeaderTitle :pageName="pagename"></HeaderTitle>
		<div class="content">
			<Back v-if="showType === 'tx'" />
			<section class="banner_div word">
				<div class="topmsg">
					<div class="m-l">
						<div>
							<!--<h3 class="font1">订单号：{{orderNo}}</h3>-->
							<h3 v-if="showType === 'tx'" class="font2" style="color:red;">{{$t('Recharge.title')}}</h3>
						</div>
					</div>
					<div class="m-r">
						{{$t('Recharge.Totalamount')}}：<span>{{$type == 1?'￥':'$'}}{{(payAmount / 100).toFixed(2)}}</span>
					</div>
				</div>

				<div class="pay-box">
					<div class="amount-input-box">
						<span class="amount-title">{{showType === 'cz' ? $t('Recharge.Recharge') : $t('Recharge.Withdrawal')}}{{ $t('Recharge.money')}}：</span>
						<input class="amount-input" v-model="amount" :placeholder="$t('Recharge.moneyinput')" type="number" @keyup="inputKeyUp"
						 @blur="inputKeyUp" />
					</div>
					<div class="amount-input-box" v-if="showType === 'tx'">
						<span class="amount-title">{{$t('Recharge.account')}}：</span>
						<input class="amount-input" v-model="accountNum" :placeholder="$t('Recharge.accountinput')" type="text" @keyup="inputKeyUp1"
						 @blur="inputKeyUp1" />
					</div>
					<div class="zfb-box" :class="alipayCheck ? 'checked-shadow' : ''" v-if="$type == 1 || $type == 3">
						<div class="z-l">
							<span class="checkbox" @click="checkPayType(1)"><span v-if="alipayCheck" class="checked-style"></span></span>
							<div class="img"><img src="@/assets/images/zfb.png" alt=""></div>
							<div class="box-font">{{$t('Recharge.Alipay')}}</div>
							<div class="box-font-m">{{$t('Recharge.txt')}}</div>
							<span class="b">{{$t('Recharge.recommend')}}</span>
						</div>
						<div class="z-r" v-if="showType === 'cz'">
							{{$t('Recharge.payment')}}<span>￥{{(payAmount / 100).toFixed(2)}}</span>
						</div>
					</div>
					<div class="zfb-box paypal-box" :class="paypalCheck ? 'checked-shadow' : ''" v-if="$type == 2 || $type == 3">
						<div class="z-l">
							<span class="checkbox" @click="checkPayType(2)"><span v-if="paypalCheck" class="checked-style"></span></span>
							<div class="img"><img src="@/assets/images/pp.png" alt=""></div>
							<div class="box-font">Paypal</div>
							<div class="box-font-m">{{$t('Recharge.international')}}</div>
						</div>
						<div class="z-r" v-if="showType === 'cz'">
							{{$t('Recharge.payment')}}<span>${{(payAmount / 100).toFixed(2)}}</span>
						</div>
					</div>
					<div class="btn-box">
						<div class="btn" @click="linkToPay">{{showType === 'cz' ? $t('Recharge.Paynow') : $t('Recharge.withdrawal')}}</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import HeaderTitle from "../assembly/HeaderTitle";
	import HeaderTop from '../assembly/HeaderTop';
	import ModelPop from '../assembly/ModelPop';
	import Back from '../assembly/Back';

	export default {
		name: "CashOrCharge",
		components: {
			HeaderTitle,
			HeaderTop,
			ModelPop,
			Back
		},
		data() {
			return {
				amount: '',
				accountNum: '',
				pagename: '收银台',
				alipayCheck: true,
				paypalCheck: false,
				payAmount: 0,
				showType: ''
			}
		},
		created() {

			let c = JSON.parse(sessionStorage.getItem('routerlinkchargecash'));
			this.token = sessionStorage.getItem('token');
			this.showType = c.type;
		},
		methods: {
			inputKeyUp(e) {
				let value = e.target.value;
				if (value === '') return;
				// value = value.replace(/[^\d]/g, '');
				let v = Number(value);
				value = v > 50000 ? '50000' : v;
				this.amount = value;
				this.payAmount = value * 100;
			},
			inputKeyUp1(e) {
				let value = e.target.value;
				if (value === '') return;
				value = value.replace(/(\s+)/g, '');
				if (value.length > 50) value = value.substring(0, 50);
				this.accountNum = value;
			},
			parentFn(payload) {
				console.log('登录' + payload)
			},

			//立即去支付
			linkToPay() {
				//调起支付
				if (this.showType === 'cz') {
					let url = 'api/account/charge/init/pay';
					this.$post(url, {
						token: this.token,
						payType: this.alipayCheck ? 1 : 2,
						amount: this.payAmount
					}).then(res => {
						document.write(res.data);
					});
				} else if (this.showType === 'tx') {
					this.$confirm(this.$t('Tips.txTips'), this.$t('Tips.Tips')).then(res => {
						this.$post('api/cash/apply', {
							cashAccount: this.accountNum,
							cashAmount: this.payAmount,
							cashType: this.alipayCheck ? 1 : 2,
							token: this.token
						}).then(res => {
							if (res.code === 0) {
								this.$message({
									type: 'success',
									message: this.$t('Tips.txsuc')
								});
								this.$router.go(-1);
								return;
							}
							this.$message({
								type: 'warning',
								message: this.$t('Tips.txfail')
							});
						});
					}).catch(() => {});
				}
			},
			//支付方式选择
			checkPayType(type) {
				switch (+type) {
					case 1:
						{
							this.alipayCheck = true;
							this.paypalCheck = false;
						}
						break;
					case 2:
						{
							this.alipayCheck = false;
							this.paypalCheck = true;
						}
						break;
				}
			}
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/pay/CashOrCharge.vue